module.exports = __webpack_public_path__ + "static/axe-df61819357f168370554bb6158ee6dc6.svg";